import React, {useEffect} from 'react';
import wrap from 'wraptile';
import {useParams} from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import handleUnmount from '@pluto/handle-unmount';
import {IngestDataPayload} from '../IngestData/IngestDataTypes';
import IngestSessionError from './IngestSessionError';
import {SessionData} from './IngestSessionInfo';
import './IngestSessionError.scss';

export const onEffect = wrap(
    ({setIngestData, id}: {setIngestData: Function; id: string}) => {
        setIngestData(id);
    }
);

export const tableColumns = [
    {
        dataKey: 'id',
        title: 'Error id',
    },
    {
        dataKey: 'message',
        title: 'Message',
    },
];

interface Props {
    ingestData: IngestDataPayload;
    setIngestData: Function;
    resetIngestData: Function;
    sessionData: SessionData;
    textEnums?: {
        feedProviders: {[key: string]: string};
        feedItemStatuses: {[key: string]: string};
    };
}

export default function IngestSessionErrorContainer(props: Props) {
    const {ingestData, setIngestData, resetIngestData, textEnums} = props;
    const {
        errors,
        title,
        provider,
        status,
        startTime,
        contentType,
        partnerName,
        isLoaded,
    } = ingestData;
    const {id} = useParams<{id: string}>();
    const fetchIngestData = onEffect({
        setIngestData,
        id,
    });

    useEffect(fetchIngestData, [setIngestData, id]);

    const onUnmount = handleUnmount(resetIngestData);

    useEffect(onUnmount, []);

    const sessionData = {
        title,
        provider,
        status,
        startTime,
        contentType,
        partnerName,
    } as SessionData;

    if (!errors || !isLoaded) {
        return <CircularProgress />;
    }

    return (
        <IngestSessionError
            textEnums={textEnums}
            data={errors}
            tableColumns={tableColumns}
            sessionData={sessionData}
        />
    );
}
